export default __webpack_public_path__ + "static/media/lightbox.6c724c9a.png";